import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-us-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "article-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "h2-title" }
const _hoisted_6 = { class: "before" }
const _hoisted_7 = { class: "after" }
const _hoisted_8 = { class: "contact-detail" }

import Breadcrumb from '@/components/Breadcrumb.vue';
import { BreadType } from '@/typeDefine/EntityType'; import NavBar from '@/components/NavBar.vue';
import { UtilMethods } from '@/util/UtilMethods';
import Footer from '@/components/Footer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

4
const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        text: 'index.navBar.contactUs'
    }
]


return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('contactUs.title')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('contactUs.contentList') as any), (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.h2Title.before), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.h2Title.after), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.contactDetail, (p, pIndex) => {
                return (_openBlock(), _createElementBlock("p", { key: pIndex }, _toDisplayString(p), 1))
              }), 128))
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})